import type { ButtonHTMLAttributes, InputHTMLAttributes, ReactNode } from "react";
import { cn } from "../lib/cn";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "ghost";
};

export function Button({ variant = "primary", className, children, ...rest }: ButtonProps) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2 text-sm font-medium transition disabled:opacity-50 disabled:cursor-not-allowed";
  const variants = {
    primary: "brand-gradient text-white hover:brightness-110",
    secondary: "border border-line bg-white text-ink hover:bg-cream-soft",
    ghost: "text-ink-muted hover:text-ink hover:bg-cream-soft",
  };
  return (
    <button className={cn(base, variants[variant], className)} {...rest}>
      {children}
    </button>
  );
}

export function Input(props: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      {...props}
      className={cn(
        "w-full rounded-xl border border-line bg-white px-3 py-2 text-sm placeholder:text-ink-muted/60 focus:outline-none focus:ring-2 focus:ring-accent-orange/30 focus:border-accent-orange/50",
        props.className,
      )}
    />
  );
}

type CardProps = {
  children: ReactNode;
  className?: string;
};

export function Card({ children, className }: CardProps) {
  return (
    <div className={cn("rounded-2xl border border-line bg-white/70 backdrop-blur-sm p-4", className)}>
      {children}
    </div>
  );
}
